import React from 'react';

export const CheckIcon: React.FC = () => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="#0ea7a2" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className="check-icon"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};
